import gql from 'graphql-tag'

const fetchDelegationsSelect = organization_id => ({
	query: gql`
		query ($organization_id: bigint) {
			organizations_territories(
				where: { organization_id: { _eq: $organization_id } }
			) {
				organizations_zones {
					organizations_delegations {
						id
						delegation_name
					}
				}
			}
		}
	`,
	update(data) {
		return data.organizations_territories
			.map(x => x.organizations_zones.map(x => x.organizations_delegations))
			.flat(2)
	},
	variables: { organization_id },
	skip: organization_id == null
})

export { fetchDelegationsSelect }
